import React, { useEffect } from 'react';
import SidebarComponent from './components/layouts/SidebarComponent';
import Login from './page/guest/Login';
import AllRoutes from './AllRoutes';
import './App.css';
import './styles/Antd.css';
import { useDispatch, useSelector } from 'react-redux';
import getThemePreset from './store/action/themeAction';
function App() {
  const dispatch = useDispatch();
  const {user} = useSelector((state: any) => state.user);

  useEffect(() => {
    if (user && Object.keys(user).length > 0) {
      dispatch<any>(getThemePreset());
    }
  }, [dispatch, user]);

  return (
    <div className="App">
      {/* <SidebarComponent/> */}
      <AllRoutes/>
    </div>
  );
}

export default App;
